import React from 'react';
import { FormattedMessage } from 'react-intl';
import dayjs from '../../../utils/dayjs';
/** Ensure a time's format is correct */
export function isTimeProper(localeTimeFormat, fieldValue, // from onchange/similar
realInputValue // from ref
) {
    if (realInputValue === undefined) {
        return true;
    }
    var timeObject = dayjs(realInputValue, localeTimeFormat, true);
    if (!timeObject.isValid()) {
        // the picker has a tendency to remove leading zeroes
        timeObject = dayjs(realInputValue, localeTimeFormat.replace('HH', 'H').replace('hh', 'h'), true);
    }
    return (timeObject.isValid() &&
        (timeObject.format('HH:mm') === fieldValue ||
            timeObject.format('HH:mm:ss') === fieldValue ||
            timeObject.format('H:mm') === fieldValue ||
            timeObject.format('H:mm:ss') === fieldValue));
}
/** ensure manually-typed dates match the proper format */
export function validateDate(values, key, dateRef, localeDateFormat) {
    var _a, _b;
    if (dateRef.current === null) {
        return {};
    }
    if (dateRef.current.value === '' &&
        (!(key in values) || typeof values[key] !== 'string')) {
        return _a = {},
            _a[key] = React.createElement(FormattedMessage, { id: "stripes-core.label.missingRequiredField" }),
            _a;
    }
    var dateValue = values[key];
    var inputValue = dateRef.current.value;
    if (dayjs(dateValue).format(localeDateFormat) !== inputValue) {
        return _b = {},
            _b[key] = (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.dateFormat", values: { localeDateFormat: localeDateFormat } })),
            _b;
    }
    return {};
}
/**
 * ensure start-date and end-date are in the proper order
 * if improper, renters an error on `end-date`
 */
export function validateDateOrder(values) {
    if (typeof values['start-date'] === 'string' &&
        values['start-date'] !== '' &&
        typeof values['end-date'] === 'string' &&
        values['end-date'] !== '' &&
        values['end-date'] < values['start-date']) {
        return {
            'end-date': (React.createElement(FormattedMessage, { id: "ui-calendar.calendarForm.error.dateOrder" }))
        };
    }
    return {};
}
